module.exports = __webpack_public_path__ + "static/media/26.9a64e376.png";